import * as a0 from "@take-2/assets/versions" with { type: "json" }
let a0_ = "" + void a0;